import React from "react";
import { Button, Modal } from "antd";
import "./function.css";
import { Cable } from "../../api";
import { useGlobal } from "../../global/user";
export default function Function1({ data, machineInfo }) {
  const { user } = useGlobal();
  const { IP, port, name } = machineInfo;
  const switchOnConfirm = () =>
    Modal.confirm({
      title: `確認執行`,
      content: `確認開啟索道 ${name} `,
      onOk: async () => {
        await Cable.CableOn(IP, port, user.name);
      },
    });
  const switchOffConfirm = () =>
    Modal.confirm({
      title: `確認執行`,
      content: `確認關閉索道 ${name} `,
      onOk: async () => {
        await Cable.CableOff(IP, port, user.name);
      },
    });
  if (user.class >= process.env.REACT_APP_EDITOR_CALSS_LV) {
    return (
      <React.Fragment>
        <td>
          <div className="d-flex justify-content-center my-1">
            {user.class >= process.env.REACT_APP_EDITOR_CALSS_LV && (
              <div>
                <Button style={{ width: 80 }} className="mr-3" onClick={switchOnConfirm} disabled={data.status === -1}>
                  ON
                </Button>
                <Button style={{ width: 80 }} onClick={switchOffConfirm} disabled={data.status === -1}>
                  OFF
                </Button>
              </div>
            )}
          </div>
        </td>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <td></td>
      </React.Fragment>
    );
  }
}
